import {Component, Injectable, OnInit} from '@angular/core';
import {defaultSpTokenResolver} from 'angular-stormpath';
import {Location} from '@angular/common';
import {UserService} from '../../../domain/model/user/user.service';
import {UserAware, UserAwareBase} from '../../../domain/model/user/user-aware.class';
import {AuthService} from '../../../components/security/authorization/auth.service';

@Component({
    template: require('./verify-email-change-page.component.html'),
    styles: [require('./verify-email-change-page.component.scss')]
})
@Injectable()
export class VerifyEmailChangePageComponent extends UserAware(UserAwareBase) implements OnInit {

    protected error: string;
    protected verifying: boolean;
    protected verified: boolean;
    protected verificationFailed: boolean;
    protected sptoken: string;

    constructor(authService: AuthService, private userService: UserService, public location: Location) {
        super(authService);
    }

    ngOnInit() {
        this.verifying = false;
        this.verified = false;
        this.verificationFailed = false;
        this.sptoken = this.spTokenResolver();
        if (this.sptoken) {
            this.verify();
        }
    }

    spTokenResolver(): string {
        return defaultSpTokenResolver(this.location);
    }

    verify() {
        this.verifying = true;
        this.userService.verifyEmailChange(this.sptoken)
            .subscribe(() => {
                this.verifying = false;
                this.verified = true;
            }, (error) => {
                this.verifying = false;
                this.verificationFailed = true;
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/account/verify/verify-email-change-page.component.ts